import request from './axios';
let baseURL = 'pc';
// 品牌分析-全国门店基础数据
/**
 * {
        "brandCode": ""
    }
 */
export function brandShopBasicData(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopBasicData',
        data,
        method: 'post'
    }).then((res) => res.data.data);
}

// 品牌分析 - 城市分布
export function listOpenCity() {
    return request({
        url: baseURL + '/v1/saas/data/listOpenCity',
        method: 'get'
    }).then((res) => res.data.data);
}

// 品牌分析-全国门店周边基础设施数据
/**
 * {
        "brandCode": "",
        "cityCode": "",
        "provinceCode": "",
        "radius": 500,
        "regionCode": ""
    }
 */
export function brandShopAroundAttrBuilding(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopAroundAttrBuilding',
        data,
        method: 'post'
    }).then((res) => res.data.data);
}

// 品牌分析-全国门店周边生活配套设施数据
/**
 * {
        "brandCode": "",
        "cityCode": "",
        "provinceCode": "",
        "radius": 0,
        "regionCode": ""
    }
 */
export function brandShopAroundAttrLife(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopAroundAttrLife',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

/*
    品牌分析-全国门店周边外卖数据
    {
        "brandCode": "",
        "cityCode": "",
        "provinceCode": "",
        "radius": 0,
        "regionCode": ""
    }
*/

export function brandShopAroundAttrWaimai(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopAroundAttrWaimai',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

/* 品牌分析-品牌开关店数量城市月度统计
    {
        "brandCode": "",
        "cityCode": "",
        "endDate": "",
        "provinceCode": "",
        "startDate": ""
    }
 */
export function brandShopOpenCloseResp(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopOpenCloseResp',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

/* 品牌分析-品牌开关店详情列表
    {
        "brandCode": "",
        "cityCode": "",
        "endDate": "",
        "provinceCode": "",
        "startDate": ""
    }
 */
export function brandShopOpenCloseDetailList(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopOpenCloseDetailList',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

// ================== 品牌对比 ===========================

// 品牌对比-全国门店基础数据
/**
 * {
        "brandCodeList": []
    }
 */
export function brandShopBasicDataBatch(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopBasicDataBatch',
        data,
        method: 'post'
    }).then((res) => res.data.data);
}

// 品牌对比-全国门店周边基础设施数据
/**
 * {
        "brandCode": [],
        "cityCode": "",
        "provinceCode": "",
        "radius": 500,
        "regionCode": ""
    }
 */
export function brandShopAroundAttrBuildingBatch(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopAroundAttrBuildingBatch',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

// 品牌对比-全国门店周边生活配套设施数据
/*
    {
        "brandCode": [],
        "cityCode": "",
        "provinceCode": "",
        "radius": 0,
        "regionCode": ""
    }
*/
export function brandShopAroundAttrLifeBatch(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopAroundAttrLifeBatch',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

// 品牌对比-全国门店周边外卖数据
/*
    {
        "brandCode": [],
        "cityCode": "",
        "provinceCode": "",
        "radius": 0,
        "regionCode": ""
    }
*/
export function brandShopAroundAttrWaimaiBatch(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandShopAroundAttrWaimaiBatch',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

// 品牌对比-门店洞察
export function brandStoreInsight(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandStoreInsight',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

// 品牌对比-导出报告
export function saveReport(data) {
    return request({
        url: baseURL + '/v4/saas/report/saveReport',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

// 品牌对比-报告PDF
export function getReportPDF(token) {
    return request({
        url: baseURL + `/v1/saas/report/pdf/newFull/${token}`,
        method: 'get'
    }).then((res) => res.data.data);
}

//获取商户绑定的竞对/协同品牌
export function getCompeteAndJoint() {
    return request({
        url: baseURL + '/v1/saas/brand/getCompeteAndJoint',
        method: 'get'
    }).then((res) => res.data.data);
}

//品牌模块下的其他列表接口
export function listBrandV3() {
    return request({
        url: baseURL + '/v1/saas/data/listBrandV3',
        method: 'get'
    }).then((res) => res.data.data);
}

//缓存数据
export function addCache(data) {
    return request({
        url: baseURL + '/v3/saas/branCache/addCache',
        method: 'post',
        data
    }).then((res) => res.data.data);
}

//获取缓存
export function getCache() {
    return request({
        url: baseURL + '/v3/saas/branCache/getCache',
        method: 'get'
    }).then((res) => res.data.data);
}

//品牌分析-品牌热力数据
export function brandHeatRes(data) {
    return request({
        url: baseURL + '/v1/saas/brandAnalysis/brandHeatRes',
        method: 'post',
        data
    });
}
